import { PlusOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { CREATE_REVIEWER_TAG, GET_REVIEWER_TAGS } from '@frontend/data-access';
import { Button, Input, InputRef } from 'antd';
import React, { useRef, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';

function CreateReviewerTag({ channelId }: { channelId: string }) {
  const { t } = useTranslation('common');
  const [name, setName] = useState('');
  const inputRef = useRef<InputRef>(null);

  const [createTag, { loading }] = useMutation(CREATE_REVIEWER_TAG, {
    refetchQueries: [{ query: GET_REVIEWER_TAGS, variables: { channelId } }],
  });

  const onChangeCustomTag = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleFinish = () => {
    if (name.trim()) {
      createTag({
        variables: {
          input: {
            name: name.trim(),
            channelId: channelId,
          },
        },
      });
    }
    setName('');
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  return (
    <div className="!w-full flex gap-2 py-1 px-2 items-center">
      <Input
        className="!w-full"
        placeholder={t('enter_tag_name')}
        value={name}
        ref={inputRef}
        onChange={onChangeCustomTag}
      />
      <Button
        type="text"
        icon={<PlusOutlined />}
        onClick={handleFinish}
        loading={loading}
      >
        {t('add_tag')}
      </Button>
    </div>
  );
}

export default CreateReviewerTag;
